import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Safety net for a known Radix issue: navigating from inside a dropdown/sheet
 * that is still dismissing can leave `body { pointer-events: none }` stuck,
 * making the destination page unclickable. Clear it on every route change so a
 * menu-then-navigate can never freeze the app.
 */
const RouteChangeUnlock = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (document.body.style.pointerEvents === "none") {
      document.body.style.pointerEvents = "";
    }
  }, [pathname]);
  return null;
};

export default RouteChangeUnlock;
